import {
  METADATA_FETCH,
  METADATA_FETCH_SUCCESS,
  METADATA_FETCH_FAILED,
} from "./available";
import {RequestState} from "../../requestState";
import vue from "vue";

import {getMetadataSection} from '../getters/metadata'


export default {
  [METADATA_FETCH](state, {table, id}) {
    const section = getMetadataSection(state)(table, id);
    vue.set(section, 'requestState', RequestState.Loading);
    vue.set(section, 'response', null);
    vue.set(section, 'error', null)
  },
  [METADATA_FETCH_SUCCESS](state, {table, id, response}) {
    const section = getMetadataSection(state)(table, id);
    vue.set(section, 'requestState', RequestState.Success);
    vue.set(section, 'response', response);
    vue.set(section, 'error', null)
  },
  [METADATA_FETCH_FAILED](state, {table, id, errorResponse}) {
    const section = getMetadataSection(state)(table, id);
    vue.set(section, 'requestState', RequestState.Failed);
    vue.set(section, 'response', null);
    vue.set(section, 'error', errorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/metadata.js